<template>
  <q-page padding>
    <div class="row col-12">
      <span class="text-brand-1 text-weight-bold text-h6"
        >Controle de Parametrizações</span
      >
    </div>
    <div
      style="font-size: 17px"
      class="text-brand-1 text-weight-medium row col-12 q-mt-xl q-mb-sm"
    >
      <span>Selecione o cliente para listar as parametrizações.</span>
    </div>
    <div class="row col-12 q-gutter-sm">
      <div class="col-3">
        <div class="text-brand-1 text-weight-bold">Cliente</div>
        <ClienteSelect v-model="cliente" />
      </div>
    </div>
    <ModalLateral
      :rightDrawerOpen="rightDrawerOpen"
      :nomeModal="`Parametrização: ${parametrizacao.parametrizacao?.nome}`"
      :tipoModal="'scroll'"
      @fecharModal="rightDrawerOpen = false"
    >
      <template v-slot:conteudo-modal>
        <FormSchema
          :schema="parametrizacao?.parametrizacao?.schema"
          :valuesSchema="parametrizacao?.default"
          :verificar="verificar"
          @valido="editarParametrizacao"
        />
      </template>
      <template v-slot:botao-modal>
        <q-btn
          class="q-mt-sm"
          color="positive"
          label="Salvar"
          icon="done"
          no-caps
          @click="verificarParametrizacao()"
        />
      </template>
    </ModalLateral>

    <div class="q-mt-xl">
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        class="my-sticky-dynamic col-12"
        dense
        :columns="columns"
        :rows="listaParametrizacoes"
        :hide-bottom="listaParametrizacoes.length > 0"
        no-data-label="Nenhuma parametrização encontrada."
        flat
      >
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              <span>{{ col.label }}</span>
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr>
            <q-td>
              {{ props.row.parametrizacao.parametrizacaoId }}
            </q-td>
            <q-td>
              {{ props.row.parametrizacao.nome }}
            </q-td>
            <q-td>
              {{ props.row.parametrizacao.descricao }}
            </q-td>
            <q-td>
              <div v-if="props.row?.parametrizacao.schema">
                <div
                  v-for="(schema, index) in props.row?.parametrizacao.schema"
                  :key="index"
                >
                  <div>
                    {{ `Campo: ${schema.name}` }}
                  </div>
                  <div>
                    {{ `Tipo: ${schema.type}` }}
                  </div>
                </div>
              </div>
            </q-td>
            <q-td>
              <div v-if="props.row?.default">
                <div v-for="(value, index) in props.row.default" :key="index">
                  {{ `${index}: ${value}` }}
                </div>
              </div>
            </q-td>
            <q-td>
              <q-btn
                icon="edit"
                round
                flat
                color="primary"
                @click="
                  (parametrizacao = { ...props.row }), (rightDrawerOpen = true)
                "
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>

    <div
      v-if="rightDrawerOpen"
      @click="(rightDrawerOpen = false), (parametrizacao = {})"
      class="mascara"
    ></div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";

import ModalLateral from "../../../components/ModalLateral.vue";
import FormSchema from "../../../components/formBuilder/Form.vue";
import ClienteSelect from "../../../components/cliente/ClienteSelect.vue";

const columns = [
  {
    name: "parametrizacaoId",
    label: "ID",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "schema",
    label: "Schema",
    align: "left",
  },
  {
    name: "default",
    label: "Valores padrão",
    align: "left",
  },
  {
    name: "editar",
    label: "Editar",
    align: "left",
  },
];

export default {
  components: { ModalLateral, FormSchema, ClienteSelect },
  setup() {
    const quasar = useQuasar();
    const store = useStore();

    const rightDrawerOpen = ref(false);
    const cliente = ref("");
    const values = ref({});
    const verificar = ref(0);
    const parametrizacao = ref({});
    const listaParametrizacoes = ref([]);
    const loading = ref(false);

    const listarParametrizacoes = async () => {
      listaParametrizacoes.value = [];
      if (
        cliente.value?.clienteId === "" ||
        cliente.value?.clienteId === undefined
      ) {
        return;
      }
      loading.value = true;

      try {
        const response = await store.dispatch("office/listarParametrizacoes", {
          clienteId: cliente.value.clienteId,
        });

        let lista = response.data.resultado.dados;

        if (lista.length > 0) {
          listaParametrizacoes.value = lista.map((elemento) => {
            (elemento.parametrizacao.schema = JSON.parse(
              elemento.parametrizacao.schema
            )),
              (elemento.default = JSON.parse(elemento.valores));
            return elemento;
          });
        }

        loading.value = false;
      } catch (error) {
        console.log(error);
        loading.value = false;
      }
    };

    const verificarParametrizacao = () => {
      verificar.value++;
    };

    const editarParametrizacao = async (object) => {
      values.value = object?.value;
      try {
        await store.dispatch("office/editarParametrizacao", {
          clienteId: cliente.value?.clienteId,
          parametrizacaoId:
            parametrizacao.value.parametrizacao.parametrizacaoId,
          schema: values.value,
        });
        quasar.notify({
          message: "Parametrização editada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        rightDrawerOpen.value = false;
        parametrizacao.value = {};
        listarParametrizacoes();
      } catch (error) {
        rightDrawerOpen.value = false;
        quasar.notify({
          message: "Erro ao editar parametrização.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => cliente.value,
      () => {
        listarParametrizacoes();
      }
    );

    onMounted(() => {
      listarParametrizacoes();
    });

    return {
      columns,
      rightDrawerOpen,
      listarParametrizacoes,
      verificarParametrizacao,
      values,
      verificar,
      editarParametrizacao,
      cliente,
      listaParametrizacoes,
      parametrizacao,
      loading,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #d9effc;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
tbody tr .coluna-btn {
  width: 120px;
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
</style>
